<template>

	<div class="page-content">
		<div class="wrapper">
			<div class="page-content__wrapper">

				<div class="page-content__aside">
					<PageNav></PageNav>
				</div>
				<slot></slot>

			</div>
		</div>
	</div>
</template>

<script>

import PageNav from "@/components/blocks/PageNav.vue";

export default {
	name: "AdminMain",
	components: {
		PageNav,
	},
}
</script>